import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section id="comprar" className="py-16 px-6 bg-navy text-cream text-center" data-id="element-27">
      <div className="max-w-3xl mx-auto space-y-8" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-29">
          <h2 className="text-3xl md:text-5xl font-serif font-bold leading-tight" data-id="element-30">
            Si hoy te identificaste, <br data-id="element-31" />
            <span className="text-terracotta" data-id="element-32">esta es tu señal.</span>
          </h2>
          <p className="text-xl text-cream/80 font-light max-w-2xl mx-auto" data-id="element-33">
            No necesitas esperar a colapsar para empezar a cuidarte. <br data-id="element-34" />
            No necesitas "tener una mejor actitud" para estar mejor. <br data-id="element-35" />
            Necesitas un mapa. Y necesitas dejar de hacerlo solo(a).
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white/5 backdrop-blur-md p-8 rounded-2xl border border-white/10 inline-block w-full max-w-md" data-id="element-36">
          <p className="text-sm text-cream/60 uppercase tracking-widest mb-2" data-id="element-37">
            Oferta Especial
          </p>
          <div className="flex items-baseline justify-center gap-2 mb-6" data-id="element-38">
            <span className="text-5xl font-bold text-white" data-id="element-39">$6.39</span>
            <span className="text-xl text-cream/60" data-id="element-40">USD</span>
          </div>

          <a href="https://tucambiohoy.online/cart/43004276899953:1" target="_blank" rel="noopener noreferrer" className="w-full bg-terracotta hover:bg-terracotta/90 text-white font-bold py-4 px-8 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 flex items-center justify-center gap-2 text-lg" data-id="element-41">
            Quiero mi Mapa de Alivio
            <ArrowRight className="w-5 h-5" data-id="element-42" />
          </a>

          <p className="mt-4 text-xs text-cream/40" data-id="element-43">
            Entrega digital inmediata en formato PDF.
          </p>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-lg font-serif italic text-cream/70" data-id="element-44">
          "Si estás listo(a) para dejar de sobrevivir y empezar a sostenerte,
          este libro es para ti."
        </motion.p>
      </div>
    </section>;
}